import React from 'react';

import { CommonFAQ } from '../SearchAndResults/StaticSections';
import { subTitle, metaDescription, sectors, appendStatic } from './common';

const pageTitle = 'Kathmandu to Pokhara Flight at USD 123';

const jomsom = {
  pageTitle,
  subTitle,
  seo: {
    title: appendStatic(pageTitle),
    description: metaDescription.concat('Online Flight Booking betweem Kathmandu and Pokhara'),
    image: 'https://s3.amazonaws.com/honeyguide/assets/book-lukla-flights-new.jpg',
  },
  from: 'KTM',
  to: 'PKR',
  sectors,
  valueProps: [
    'Price Match Guarantee',
    'Free 24 hours cancellation',
    '24x7 support from HoneyGuide',
  ],
  Faq: () => {
    return (
      <React.Fragment>
        <CommonFAQ />
      </React.Fragment>
    );
  }
};

export default jomsom;



// WEBPACK FOOTER //
// ./src/screens/Flights/static-db/pokhara.js